import React from 'react';
import LinksFooter, {
  LinksFooterProps,
} from '../../../../../../components/App/footer/LinksFooter/LinksFooter';
import logo_footer from '../../../../assets/SCC-Logo_White.svg';

import {
  AppBar,
  Box,
  Link,
  Toolbar,
  alpha,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { getPolyglot } from '../../../../../../i18n';

const LinkStyled: typeof Link = styled(Link)(({ theme }) => ({
  color: theme.palette.secondary.contrastText,
  textDecoration: 'underline',
  '&:hover': {
    color: alpha(theme.palette.secondary.contrastText, 0.8),
  },
})) as typeof Link;

function LinksFooterFW(props: LinksFooterProps) {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const {
    logoFooter = logo_footer,
    urlAboutUs = 'https://structuralconcepts.com/',
    ...appBarProps
  } = props;
  const urlTermsAndConditions =
    'https://djnnwndagrfti.cloudfront.net/resources/Shared/TERMS_AND_CONDITIONS_OF_SALE.pdf';
  const urlPrivacyPolicy = 'https://structuralconcepts.com/privacy-policy';
  const LinkComponent = LinkStyled;
  const polyglot = getPolyglot();
  return (
    <AppBar
      position="static"
      component={'footer'}
      color="primary"
      sx={{
        alignItems: 'center',
        display: { xs: 'none', md: 'flex' },
        backgroundColor: theme.palette.primary.dark,
      }}
      {...appBarProps}
    >
      <Toolbar
        sx={{
          height: '4rem',
          maxWidth: 1536,
          justifyContent: 'space-between',
          mx: 2,
          gap: 2,
          width: '100%',
          margin: 'auto',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <Box
          sx={{
            gap: { lg: '4rem', md: '2rem' },
            display: 'flex',
          }}
        >
          <LinkComponent href={urlTermsAndConditions} target="_blank">
            {polyglot.t('footer.terms_and_conditions')}
          </LinkComponent>
        </Box>
        <Box
          sx={{
            gap: { lg: '4rem', md: '2rem' },
            display: 'flex',
          }}
        >
          <LinkComponent href={urlPrivacyPolicy} target="_blank">
            {polyglot.t('footer.privacy_policy')}
          </LinkComponent>
        </Box>
        <Box
          sx={{
            gap: { lg: '4rem', md: '2rem' },
            display: 'flex',
          }}
        >
          <LinkComponent href={urlAboutUs} target="_blank">
            {polyglot.t('footer.about_us')}
          </LinkComponent>
        </Box>

        {!!logoFooter && (
          <img src={logoFooter} height={isTablet ? 20 : 30} alt="logo-scc" />
        )}
      </Toolbar>
    </AppBar>
  );
}

export default LinksFooterFW;
